import { DEFAULT_DATE_LOCALE } from '@lumapps/constants';

import { logException } from '../log/logException';
import { GMT_TRANSLATIONS } from './timeZones';

/**
 * Returns the given timezone's localized offset.
 * If the language key is passed, the offset is localized based on that language dans can return a wide variety of string.
 * If this method is used to get an offset to be used to generate a Date, do not pass any language and use the DEFAULT_DATE_LOCAL to get a GMT format.
 * Example: GMT+01:00 or UTC+01:00.
 * @param options
 * @returns offset
 */
export const getTimeZoneOffset = ({
    date,
    timeZone,
    language = DEFAULT_DATE_LOCALE,
    format = 'longOffset',
}: {
    date?: Date;
    language?: string;
    timeZone: NonNullable<Intl.DateTimeFormatOptions['timeZone']>;
    format?: Intl.DateTimeFormatOptions['timeZoneName'];
}) => {
    try {
        const formatter = new Intl.DateTimeFormat(language, {
            timeZone,
            timeZoneName: format,
        });
        const parts = formatter.formatToParts(date || new Date());
        const offset = parts.find((part) => part.type === 'timeZoneName')?.value as string;

        /**
         * If the offset is one of the GMT translations, it means that the difference with GMT is 0. The text by default
         * only says GMT, so we add the +00:00 so that it has the same format as the other time zones.
         */
        return GMT_TRANSLATIONS.includes(offset) ? `${offset}+00:00` : offset;
    } catch (excp) {
        logException(excp);
    }

    return '';
};
